import { render, staticRenderFns } from "./DevicetypesView.vue?vue&type=template&id=e9584684&"
import script from "./DevicetypesView.vue?vue&type=script&lang=js&"
export * from "./DevicetypesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports